import { Link, NavLink } from "react-router-dom";

import { ContactSection } from "./components/ContactSection";
import { Container } from "./components/Container";
import { FadeIn, FadeInStagger } from "./components/FadeIn";
import { List, ListItem } from "./components/List";
import { SectionIntro } from "./components/SectionIntro";
import { StylizedImage } from "./components/StylizedImage";
import { Testimonial } from "./components/Testimonial";
import logoBrightPath from "./images/clients/bright-path/logo-light.svg";
import logoFamilyFund from "./images/clients/family-fund/logo-light.svg";
import logoGreenLife from "./images/clients/green-life/logo-light.svg";
import logoHomeWork from "./images/clients/home-work/logo-light.svg";
import logoMailSmirk from "./images/clients/mail-smirk/logo-light.svg";
import logoNorthAdventures from "./images/clients/north-adventures/logo-light.svg";
import logoPhobiaDark from "./images/clients/phobia/logo-dark.svg";
import logoPhobiaLight from "./images/clients/phobia/logo-light.svg";
import logoUnseal from "./images/clients/unseal/logo-light.svg";
import imageLaptop from "./images/laptop.jpg";

import statue1 from "./images/statue1.jpg";
import statue2 from "./images/statue2.jpg";
import statue3 from "./images/statue3.jpg";
import statue4 from "./images/statue4.jpg";
import statue5 from "./images/statue5.jpg";
import statue6 from "./images/statue6.jpg";
import statue7 from "./images/statue7.jpg";
import statue8 from "./images/statue8.jpg";
import statue9 from "./images/statue9.jpg";
import statue10 from "./images/statue10.jpg";
import statue11 from "./images/statue11.jpg";

const works = [
  {
    client: "DergiPark",
    title: "The biggest platform for digital content in Türkiye.",
    description:
      "It is a leading platform for academic publications and digital archiving solutions, providing a comprehensive digital library for researchers, academics, and publishers.",
    summary: [
      "Under the umbrella of TÜBİTAK ULAKBİM, DergiPark provides hosting and editorial process management services in electronic format for academic peer-reviewed journals published in Turkey. DergiPark supports national academic journals in gaining presence in accordance with standards and increasing their international visibility.",
      "DergiPark does not interfere with the operation, management, or content of journals and does not take sides in cases of conflicts of interest or ethical violations. It only provides infrastructure and technical support for the use of the system. Authors should contact the editor and publisher of the relevant journal for all matters regarding their publications.",
    ],
    logoImage: {
      src: "https://dergipark.org.tr/zollu/images/dergipark_header.png",
    },
    image: { src: "imageHero" },
    date: "2014-01",
    class: "AI and Software",
    service: "AI and Information",
    testimonial: {
      author: { name: "Debra Fiscal", role: "CEO of FamilyFund" },
      content:
        "Working with Studio, we felt more like a partner than a customer. They really resonated with our mission to change the way people convince their parents to cash out their pensions.",
    },
    href: "/works",
  },
  {
    client: "Suyabakan",
    title: "AI and IoT powered smart agriculture technologies.",
    description:
      "We deliver solutions for the agriculture industry by integrating smart devices and software, enabling effectiveness across diverse categories through our extensive product portfolio and robust software solutions.",
    summary: [
      "Unseal is the first NFT platform where users can mint and trade NFTs of their own personal health records, allowing them to take control of their data.",
      "We built out the blockchain infrastructure that supports Unseal. Unfortunately, we took a massive loss on this project when Unseal’s cryptocurrency, PlaceboCoin, went to zero.",
    ],
    logo: "",
    logoImage: {
      src: "https://cdn.dribbble.com/userupload/5065657/file/original-cd9cb73b18d84318f46043cec60030c1.png?resize=752x593&vertical=center",
    },
    image: { src: "imageHero" },
    date: "2022-10",
    class: "Hardware, AI and Software",
    service: "Smart Agriculture",
    testimonial: {
      author: { name: "Emily Selman", role: "Head of Engineering at Unseal" },
      content:
        "Studio did an amazing job building out our core blockchain infrastructure and I’m sure once PlaceboCoin rallies they’ll be able to finish the project.",
    },
    href: "/works",
  },
  {
    client: "Sentinen",
    title: "Utility solutions using AI, hardware and software.",
    description:
      "We provide solutions to many issues in the electricity distribution sector, develop projects, and deliver products at the end of those projects.",
    summary: [
      "Find love in the face of fear — Phobia is a dating app that matches users based on their mutual phobias so they can be scared together.",
      "We worked with Phobia to develop a new onboarding flow. A user is shown pictures of common phobias and we use the microphone to detect which ones make them scream, feeding the results into the matching algorithm.",
    ],
    logoImage: {
      src: "https://cdn.dribbble.com/userupload/10378002/file/original-0e71eef6b2f8eb7fd15fd3da9ce19467.png?resize=2048x1664&vertical=center",
    },
    image: { src: "imageHero" },
    date: "2022-06",
    class: "Hardware and Software",
    service: "NextGen Utility",
    testimonial: {
      author: { name: "Jenny Wilson", role: "CPO of Phobia" },
      content:
        "The team at Studio went above and beyond with our onboarding, even finding a way to access the user’s microphone without triggering one of those annoying permission dialogs.",
    },
    href: "/works",
  },
];
const clients = [
  ["Phobia", logoPhobiaLight],
  ["Family Fund", logoFamilyFund],
  ["Unseal", logoUnseal],
  ["Mail Smirk", logoMailSmirk],
  ["Home Work", logoHomeWork],
  ["Green Life", logoGreenLife],
  ["Bright Path", logoBrightPath],
  ["North Adventures", logoNorthAdventures],
];
function Clients() {
  return (
    <div className="mt-24 rounded-4xl dark-section bg-neutral-950 py-20 sm:mt-32 sm:py-32 lg:mt-64">
      <Container className="dark-section">
        <FadeIn className="flex items-center gap-x-8 dark-section">
          <h2 className=" dark-section text-center font-display text-sm font-semibold tracking-wider text-white sm:text-left">
            We have worked with hundreds of amazing people
          </h2>
          <div className="h-px dark-section flex-auto bg-neutral-800" />
        </FadeIn>
        <FadeInStagger faster className="dark-section">
          <div className="h-40"></div>
          {/* <ul
            role="list"
            className="mt-10 dark-section grid grid-cols-2 gap-x-8 gap-y-10 lg:grid-cols-4"
          >
            {clients.map(([client, logo]) => (
              <li key={client} className="dark-section">
                <FadeIn className="dark-section">
                  <img
                    className="dark-section"
                    src={logo}
                    alt={client}
                    unoptimized
                  />
                </FadeIn>
              </li>
            ))}
          </ul> */}
        </FadeInStagger>
      </Container>
    </div>
  );
}

function CaseStudies() {
  return (
    <>
      <SectionIntro
        eyebrow="Our Brands"
        title="We utilize technology to create a better tomorrow."
        className="mt-24 sm:mt-32 lg:mt-40 "
      >
        <p>
          Along this journey, we have developed brands that serve various
          industries.
        </p>
      </SectionIntro>
      <Container className="mt-16">
        <FadeInStagger className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {works.map((work) => (
            <FadeIn key={work.href} className="flex">
              <article className="relative flex w-full flex-col rounded-3xl p-6 ring-1 ring-neutral-950/5 transition hover:bg-neutral-50 sm:p-8">
                <h3>
                  <Link
                    to={{
                      pathname: "/works",
                      hash: work.client,
                    }}
                  >
                    <span className="absolute inset-0 rounded-3xl" />
                    <img
                      src={work.logoImage.src}
                      alt={work.client}
                      className={
                        work.client == "DergiPark"
                          ? "my-5 h-14"
                          : "h-24 " + " w-auto"
                      }
                      unoptimized
                    />
                  </Link>
                </h3>
                <p className="mt-6 flex gap-x-2 text-sm text-neutral-950">
                  <time
                    dateTime={work.date.split("-")[0]}
                    className="font-semibold"
                  >
                    {work.service}
                  </time>
                  <span className="text-neutral-300" aria-hidden="true">
                    /
                  </span>
                  <span>{work.class}</span>
                </p>
                <p className="mt-6 font-display text-2xl font-semibold text-neutral-950">
                  {work.title}
                </p>
                <p className="mt-4 text-base text-neutral-600">
                  {work.description}
                </p>
              </article>
            </FadeIn>
          ))}
        </FadeInStagger>
      </Container>
    </>
  );
}

function Services() {
  return (
    <>
      <SectionIntro
        eyebrow="Our Services"
        title=" We create value-driven projects."
        className="mt-24 sm:mt-32 lg:mt-40"
      >
        <p>
          Through our innovative engineering methods, skilled team, and
          expertise, we create value-driven projects.
        </p>
      </SectionIntro>
      <Container className="mt-16">
        <Link
          to={"/services"}
          className="lg:flex lg:items-center lg:justify-end"
        >
          <div className="flex justify-center lg:w-1/2 lg:justify-end lg:pr-1">
            <FadeIn className="w-[33.75rem] flex-none lg:w-[55rem]">
              <StylizedImage
                src={statue9}
                sizes="(min-width: 1024px) 41rem, 31rem"
                className="justify-center  lg:justify-end"
              />
            </FadeIn>
          </div>
          <List className="mt-16 lg:mt-0 lg:w-1/2 lg:min-w-[33rem] lg:pl-4">
            <ListItem title="AI and information">
              AI transforms how information is processed, analyzed, and
              utilized, enabling smarter decisions and unlocking new
              possibilities.
            </ListItem>
            <ListItem title="Field data">
              Collecting field data ensures precise monitoring of environmental
              and operational conditions.
            </ListItem>
            <ListItem title="Smart agriculture">
              By using IoT and AI, smart agriculture transforms resource
              management and crop yield.
            </ListItem>
            <ListItem title="NextGen utility">
              NextGen utilities drive smarter, more sustainable solutions for
              energy and resources.
            </ListItem>
          </List>
        </Link>
      </Container>
    </>
  );
}

export default function Home() {
  window.scrollTo(0, 0);
  return (
    <>
      <Container className="mt-24 sm:mt-32 md:mt-48 ransition-all duration-500">
        <FadeIn className="max-w-3xl ransition-all duration-500 ">
          <h1 className=" font-sans rounded-t-full pt-10 pb-2 bg-whit mix-blend-exclusio  text-5xl font-black tracking-tight text-neutral-950 [text-wrap:balance] sm:text-7xl">
            Award-winning technology company.
          </h1>
          <p className="mt-0 max-w-2xl rounded-b-xl pt-6 pb-8 pr-12 text-xl bg-whit mix-blend-exclusio text-neutral-600 ">
            We use{" "}
            <strong className="font-semibold text-neutral-950">AI</strong> and
            develop <strong className="font-semibold text-neutral-950">hardware</strong>  and {" "}
            <strong className="font-semibold text-neutral-950">software</strong> . From agricultural technologies to
            academic solutions, we offer a wide range of innovative products.
          </p>
          {/* <img
            src={statue3}
            alt=""
            className="absolute h-[60rem] top-0 -right-56 -z-10   mt-16  rounded-full"
          /> */}
        </FadeIn>
      </Container>
      <img
        src={statue11}
        alt=""
        className="transition-all duration-500 absolute w-[100rem]  top-0 -right-96 max-sm:-right-40 max-sm:-top-12 -z-10 grayscale-[100%] mix-blend-multiply invert  mt-16  rounded-b-full rounded-t-[2000rem] "
      />

      <Clients />

      <CaseStudies />

      <Testimonial
        className="mt-24 sm:mt-32 lg:mt-40"
        client={{ name: "", logo: "logoPhobiaDark" }}
      >
        Yonca Teknoloji exceeded our expectations and provided a truly seamless experience with their excellent software solutions, professional teamwork, and customer-centric approach.
      </Testimonial>

      <Services />

      <ContactSection />
    </>
  );
}
